module.exports = __webpack_public_path__ + "media/images/athletes/52-06f3aa40593a89d2740614e26e7729d4.png";